export default __webpack_public_path__ + "static/media/09-BB-(2-1).a63eb8a7.jpg";